import { useState, useEffect } from "react";

import Cookies from "universal-cookie";

import env, { normalPriceCount } from "../env";

import errortrans from "../translate/error";

import Configuration from "./Configuration";

import Setting from "./Setting";

const Header = (props) => {
  const cookies = new Cookies();

  const [configure, setConfigure] = useState(0);
  const [setting, setSetting] = useState(0);
  const [LivePrice, setLivePrice] = useState(0);
  const [goldLastUpdate, setGoldLastUpdate] = useState(null);
  const [Refresh, setRefresh] = useState(0);
  const [sepidarLastUserName, setSepidarLastUserName] = useState(null);
  const [sepidarStatus, setSepidarStatus] = useState(null);
  const [sepidarLastUpdate, setSepidarLastUpdate] = useState(null);
  const [sepidarLoading, setSepidarLoading] = useState(false);
  const token = cookies.get(env.cookieName) || 1;

  const lang = props.lang ? props.lang.lang : errortrans.defaultLang;

  const logOff = () => {
    cookies.remove(env.cookieName, { path: "/" });
    setTimeout(() => (document.location.reload(), 500));
  };

  // قیمت طلا
  useEffect(() => {
    setLivePrice("");

    const postOptions = {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token && token.token,
        userId: token && token.userId,
      },
    };

    fetch(env.siteApi + "/panel/faktor/price", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          setLivePrice(result?.data ?? 0);
          setGoldLastUpdate(result?.lastUpdate ?? null);
        },
        (error) => {
          console.log(error);
          setGoldLastUpdate(null);
        },
      );
  }, [Refresh]);

  // بررسی وضعیت اتصال سپیدار
  const checkSepidarStatus = () => {
    setSepidarLoading(true);

    const postOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token && token.token,
        userId: token && token.userId,
      },
    };

    fetch(env.siteApi + "/setting/check-server", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          setSepidarStatus(result?.data ?? false);
          setSepidarLastUpdate(result?.lastTime ?? null);
          setSepidarLastUserName(result?.lastUserName ?? null);
        },
        (error) => {
          console.log(error);
          setSepidarStatus(false);
          setSepidarLastUpdate(null);
          setSepidarLastUserName(null);
        },
      )
      .catch((error) => {
        console.log(error);
        setSepidarStatus(false);
        setSepidarLastUpdate(null);
        setSepidarLastUserName(null);
      })
      .finally(() => {
        setSepidarLoading(false);
      });
  };

  // بررسی اولیه + هر 10 دقیقه
  useEffect(() => {
    checkSepidarStatus();

    const interval = setInterval(
      () => {
        checkSepidarStatus();
      },
      10 * 60 * 1000,
    );

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <nav
      className="navbar topMenu navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl"
      style={{ direction: props.lang.dir }}
      id="navbarBlur"
      data-scroll="true"
    >
      <div className="container-fluid py-1 px-3">
        <nav className="collapseMenu nav-item d-xl-none ps-3 d-flex align-items-center">
          <a
            href="#"
            className="nav-link text-body p-0"
            id="iconNavbarSidenav"
            onClick={() => props.setPinMenu(props.pinMenu ? 0 : 1)}
          >
            <div className="sidenav-toggler-inner">
              <i className="sidenav-toggler-line"></i>
              <i className="sidenav-toggler-line"></i>
              <i className="sidenav-toggler-line"></i>
            </div>
          </a>
        </nav>

        <nav aria-label="breadcrumb" className="hideMobile"></nav>

        <div
          className="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4"
          id="navbar"
        >
          <div className="d-flex align-items-center gap-3">
            {/* قیمت طلا */}
            <span
              className="LivePrice"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "2px",
              }}
            >
              <span
                className="d-flex align-items-center"
                style={{
                  gap: "6px",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span>قیمت طلا:</span>

                <span>{normalPriceCount(LivePrice)}</span>

                <i
                  onClick={() => setRefresh(Refresh + 1)}
                  className="fa fa-refresh"
                  aria-hidden="true"
                  style={{ cursor: "pointer" }}
                  title="بروزرسانی قیمت طلا"
                ></i>
              </span>

              {goldLastUpdate && (
                <span
                  style={{
                    fontSize: "11px",
                    color: "#6c757d",
                    textAlign: "center",
                  }}
                >
                  بروزرسانی: {new Date(goldLastUpdate).toLocaleString("fa-IR")}
                </span>
              )}
            </span>

            {/* وضعیت سپیدار */}
            <span
              className="SepidarStatus"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "2px",
              }}
            >
              <span
                className="d-flex align-items-center"
                style={{ gap: "6px" }}
              >
                <span>وضعیت ته حساب:</span>

                {sepidarLoading ? (
                  <>
                    <span>در حال بررسی...</span>
                    <i className="fa fa-refresh fa-spin" aria-hidden="true"></i>
                  </>
                ) : (
                  <>
                    <span
                      style={{
                        color: sepidarStatus ? "#28a745" : "#dc3545",
                        fontWeight: "bold",
                      }}
                    >
                      {sepidarStatus ? "متصل" : "قطع"}
                    </span>

                    <i
                      onClick={checkSepidarStatus}
                      className="fa fa-refresh"
                      aria-hidden="true"
                      style={{
                        cursor: "pointer",
                      }}
                      title="بررسی مجدد اتصال ته حساب"
                    ></i>
                  </>
                )}
              </span>

              {!sepidarLoading && sepidarLastUpdate && (
                <span
                  style={{
                    fontSize: "11px",
                    color: "#6c757d",
                    textAlign: "center",
                  }}
                >
                  {sepidarLastUserName}:{" "}
                  {new Date(sepidarLastUpdate).toLocaleString("fa-IR")}
                </span>
              )}
            </span>
          </div>

          <ul
            className={`${
              props.lang.dir === "ltr" ? "ms-md-auto" : "ms-md-right"
            } navbar-nav justify-content-end`}
          >
            <li className="nav-item d-flex align-items-center hideMobile">
              <a
                className="btn btn-outline-primary btn-sm mb-0 me-3"
                target="_blank"
                href="https://psyum.3cx.eu:5443/ahmad"
                rel="noreferrer"
              >
                {errortrans.support[lang]}
              </a>
            </li>

            <li className="nav-item d-flex align-items-center">
              <a
                href="#"
                className="nav-link text-body p-0"
                onClick={() => setSetting(1)}
              >
                <i className="fa fa-wrench fixed-plugin-button-nav cursor-pointer"></i>
              </a>
            </li>

            <li className="nav-item d-flex align-items-center">
              <a
                href="/messages"
                className="nav-link text-body p-0"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa fa-bell cursor-pointer"></i>
              </a>

              <ul
                className="dropdown-menu dropdown-menu-end px-2 py-3 me-sm-n4"
                aria-labelledby="dropdownMenuButton"
              >
                <li className="mb-2">
                  <a className="dropdown-item border-radius-md" href="#">
                    <div className="d-flex py-1">
                      <div className="my-auto">
                        <img
                          src="../assets/img/team-2.jpg"
                          className="avatar avatar-sm me-3"
                          alt=""
                        />
                      </div>

                      <div className="d-flex flex-column justify-content-center">
                        <h6 className="text-sm font-weight-normal mb-1">
                          <span className="font-weight-bold">New message</span>{" "}
                          from Laur
                        </h6>

                        <p className="text-xs text-secondary mb-0">
                          <i className="fa fa-clock me-1"></i>
                          13 minutes ago
                        </p>
                      </div>
                    </div>
                  </a>
                </li>

                <li className="mb-2">
                  <a className="dropdown-item border-radius-md" href="#">
                    <div className="d-flex py-1">
                      <div className="my-auto">
                        <img
                          src="../assets/img/small-logos/logo-spotify.svg"
                          className="avatar avatar-sm bg-gradient-dark me-3"
                          alt=""
                        />
                      </div>

                      <div className="d-flex flex-column justify-content-center">
                        <h6 className="text-sm font-weight-normal mb-1">
                          <span className="font-weight-bold">New album</span> by
                          Travis Scott
                        </h6>

                        <p className="text-xs text-secondary mb-0">
                          <i className="fa fa-clock me-1"></i>1 day
                        </p>
                      </div>
                    </div>
                  </a>
                </li>

                <li>
                  <a className="dropdown-item border-radius-md" href="#">
                    <div className="d-flex py-1">
                      <div className="avatar avatar-sm bg-gradient-secondary me-3 my-auto"></div>

                      <div className="d-flex flex-column justify-content-center">
                        <h6 className="text-sm font-weight-normal mb-1">
                          Payment successfully completed
                        </h6>

                        <p className="text-xs text-secondary mb-0">
                          <i className="fa fa-clock me-1"></i>2 days
                        </p>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </li>

            <li className="nav-item d-flex align-items-center">
              <a href="#" className="nav-link text-body font-weight-bold px-0">
                <i className="fa fa-user me-sm-1"></i>
                <span>{token.username.split("undefined")[0]}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <Configuration show={configure} setConfigure={setConfigure} />

      <Setting show={setting} setSetting={setSetting} lang={lang} />
    </nav>
  );
};

export default Header;
